import { isServerMode, isUsePgliteDB } from '@/const/version';

import { GlobalState, INITIAL_STATUS } from '../initial-state';

export const systemStatus = (s: GlobalState) => s.status;

const showHeader = (s: GlobalState) =>
  !s.status.zenMode && (s.status.showHeader ?? INITIAL_STATUS.showHeader);
const showSidebar = (s: GlobalState) =>
  !s.status.zenMode && (s.status.showSidebar ?? INITIAL_STATUS.showSidebar);

const sessionGroupKeys = (s: GlobalState): string[] =>
  s.status.expandSessionGroupKeys || INITIAL_STATUS.expandSessionGroupKeys;

const showSystemRole = (s: GlobalState) => s.status.showSystemRole;
const mobileShowTopic = (s: GlobalState) =>
  showSidebar(s) && (s.status.mobileShowTopic ?? INITIAL_STATUS.mobileShowTopic);
const mobileShowPortal = (s: GlobalState) => s.status.mobileShowPortal;
const showChatSideBar = (s: GlobalState) =>
  showSidebar(s) && (s.status.showChatSideBar ?? INITIAL_STATUS.showChatSideBar);
const showConversationPanel = (s: GlobalState) =>
  showSidebar(s) && (s.status.showConversationPanel ?? INITIAL_STATUS.showConversationPanel);
const showFilePanel = (s: GlobalState) => s.status.showFilePanel;
const showImagePanel = (s: GlobalState) => s.status.showImagePanel;
const showImageTopicPanel = (s: GlobalState) => s.status.showImageTopicPanel;
const showGlobalLoading = (s: GlobalState) =>
  s.status.showGlobalLoading ?? INITIAL_STATUS.showGlobalLoading;
const showSidebarToggle = (s: GlobalState) =>
  s.status.showSidebarToggle ?? INITIAL_STATUS.showSidebarToggle;
const isEmbedIframe = (s: GlobalState) => s.status.isEmbedIframe ?? INITIAL_STATUS.isEmbedIframe;

const hidePWAInstaller = (s: GlobalState) => s.status.hidePWAInstaller;
const isShowCredit = (s: GlobalState) => s.status.isShowCredit;
const themeMode = (s: GlobalState) => s.status.themeMode || 'light';
const language = (s: GlobalState) => s.status.language || 'auto';

const showChatHeader = (s: GlobalState) => showHeader(s);
const inZenMode = (s: GlobalState) => s.status.zenMode;
const sessionWidth = (s: GlobalState) => s.status.conversationWidth;
const sideBarStyle = (s: GlobalState) => s.status.sideBarStyle;
const messageListStyle = (s: GlobalState) => s.status.messageListStyle;
const portalWidth = (s: GlobalState) => s.status.portalWidth || 400;
const filePanelWidth = (s: GlobalState) => s.status.filePanelWidth;
const imagePanelWidth = (s: GlobalState) => s.status.imagePanelWidth;
const imageTopicPanelWidth = (s: GlobalState) => s.status.imageTopicPanelWidth;
const inputHeight = (s: GlobalState) => s.status.inputHeight;

const embedParams = (s: GlobalState) => s.embedParams;
const embeddedAppUrl = (s: GlobalState) => s.embeddedAppUrl ?? null;
const workspaceContext = (s: GlobalState) => s.workspaceContext ?? null;

const isPgliteNotEnabled = (s: GlobalState) =>
  isUsePgliteDB && !isServerMode && s.isStatusInit && !s.status.isEnablePglite;

const getAgentSystemRoleExpanded =
  (agentId: string) =>
  (s: GlobalState): boolean => {
    const map = s.status.systemRoleExpandedMap || {};
    return map[agentId] !== false;
  };

export const systemStatusSelectors = {
  embedParams,
  embeddedAppUrl,
  workspaceContext,
  filePanelWidth,
  getAgentSystemRoleExpanded,
  hidePWAInstaller,
  imagePanelWidth,
  imageTopicPanelWidth,
  inZenMode,
  isEmbedIframe,
  inputHeight,
  isPgliteNotEnabled,
  isShowCredit,
  language,
  mobileShowPortal,
  mobileShowTopic,
  portalWidth,
  sessionGroupKeys,
  sessionWidth,
  sideBarStyle,
  messageListStyle,
  showHeader,
  showSidebar,
  showChatHeader,
  showChatSideBar,
  showFilePanel,
  showImagePanel,
  showImageTopicPanel,
  showConversationPanel,
  showGlobalLoading,
  showSidebarToggle,
  showSystemRole,
  systemStatus,
  themeMode,
};
